module.exports = __webpack_public_path__ + "img/14.4949e5e0.svg";